module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRosegold.2025c1f.webp";